/* ===========================================================
   IMPORTS
=========================================================== */

// Gallantry Images
import imgPv from "./components/images/pv_chakra.png";
import imgAc from "./components/images/a_chakra.png";
import imgMv from "./components/images/mv_chakra.png";
import imgVc from "./components/images/Veer_chakra.png";
import imgKc from "./components/images/k_chakra.png";
import imgSc from "./components/images/S_Chakra.png";

// Civilian Images
import c1 from "./components/images/z1.png";
import c2 from "./components/images/z2.png";
import c3 from "./components/images/z3.png";
import c4 from "./components/images/z4.png";

// Importing category data files
import { artsAwardsData } from "./components/ArtsAwards";
import { scienceAwardsData } from "./components/ScienceAwards";
import { literatureAwardsData } from "./components/LitAwards";
import { sportsAwardsData } from "./components/SportsAwards";
import { socialAwardsData } from "./components/SocialAwards";
import { businessAwardsData } from "./components/BussAwards";
import { stateAwardsData } from "./components/StateAwards";
import { internationalAwardsData } from "./components/InterAwards";


/* ===========================================================
   1) GALLANTRY AWARDS
=========================================================== */
export const gallantryAwards = [
  {
    category: "Gallantry",
    htext: "Param Vir Chakra",
    ptext: "Highest wartime gallantry award.",
    img1: imgPv,
    modalContent: `
      <b>Established:</b>1950<br/>
      <b>First Recipient:</b>Major Somnath Sharma<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Param_Vir_Chakra'>Wiki link</a>
    `
  },
  {
    category: "Gallantry",
    htext: "Ashoka Chakra",
    ptext: "Highest peacetime gallantry award.",
    img1: imgAc,
    modalContent: `
      <b>Established:</b>1950<br/>
      <b>Awarded For:</b>Peacetime bravery<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Ashoka_Chakra'>Wiki link</a>
    `
  },
  {
    category: "Gallantry",
    htext: "Maha Vir Chakra",
    ptext: "Second-highest wartime gallantry recognition.",
    img1: imgMv,
    modalContent: `
      <b>For:</b>Bravery during war<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Maha_Vir_Chakra'>Wiki link</a>
    `
  },
  {
    category: "Gallantry",
    htext: "Vir Chakra",
    ptext: "Awarded for bravery in battle.",
    img1: imgVc,
    modalContent: `
      <b>For:</b>Gallantry in presence of enemy<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Vir_Chakra'>Wiki link</a>
    `
  },
  {
    category: "Gallantry",
    htext: "Kirti Chakra",
    ptext: "Valour & courageous action during peacetime.",
    img1: imgKc,
    modalContent: `
      <b>Type:</b>Peacetime gallantry<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Kirti_Chakra'>Wiki link</a>
    `
  },
  {
    category: "Gallantry",
    htext: "Shaurya Chakra",
    ptext: "Awarded for exceptional courage during operations.",
    img1: imgSc,
    modalContent: `
      <b>Type:</b>Peacetime gallantry<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Shaurya_Chakra'>Wiki link</a>
    `
  }
];


/* ===========================================================
   2) CIVILIAN AWARDS
=========================================================== */
export const civilianAwards = [
  {
    category: "Civilian",
    htext: "Bharat Ratna",
    ptext: "India's highest civilian honour.",
    img1: c1,
    modalContent: `
      <b>Established:</b>1954<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Bharat_Ratna'>Wiki link</a>
    `
  },
  {
    category: "Civilian",
    htext: "Padma Vibhushan",
    ptext: "Second highest civilian award.",
    img1: c2,
    modalContent: `
      <b>Established:</b>1954<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Padma_Vibhushan'>Wiki link</a>
    `
  },
  {
    category: "Civilian",
    htext: "Padma Bhushan",
    ptext: "Third-highest civilian award.",
    img1: c3,
    modalContent: `
      <b>Established:</b>1954<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Padma_Bhushan'>Wiki link</a>
    `
  },
  {
    category: "Civilian",
    htext: "Padma Shri",
    ptext: "Awarded for distinguished service in any field.",
    img1: c4,
    modalContent: `
      <b>Established:</b>1954<br/>
      <br/><a href='https://en.wikipedia.org/wiki/Padma_Shri'>Wiki link</a>
    `
  }
];


/* ===========================================================
   COMBINED SEARCH DATA
=========================================================== */

export const allAwards = [
  ...gallantryAwards,
  ...civilianAwards,
  ...artsAwardsData,
  ...scienceAwardsData,
  ...literatureAwardsData,
  ...sportsAwardsData,
  ...socialAwardsData,
  ...businessAwardsData,
  ...stateAwardsData,
  ...internationalAwardsData
];
